import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";

enum CotaServiceEnum {
  requestUpdateDatasCota = "update-datas-by-tradeId/"
}

export default class QuotaService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/quota/");
  }

  public requestUpdateDatasCota = async (tradeId: number) => {
    const data = this.POST(CotaServiceEnum.requestUpdateDatasCota + tradeId, null);
    
    return data;
};
}



// WEBPACK FOOTER //
// ./src/services/api/Cota.service.ts